import React from 'react';
import { ShieldCheck, RefreshCw, XCircle } from 'lucide-react';

const TRUST_POINTS = [
  { icon: ShieldCheck, text: 'Sin coste de instalación' },
  { icon: RefreshCw, text: 'Cambia de plan cuando lo necesites' },
  { icon: XCircle, text: 'Sin permanencia, cancela cuando quieras' },
];

export function PricingHero() {
  return (
    <section data-testid="pricing-hero" className="relative pt-40 pb-16 px-6 text-center overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-[#00E5FF]/10 blur-[120px] pointer-events-none" />
      <div className="relative max-w-3xl mx-auto">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white leading-[1.05]">
          Un plan para cada tamaño de tienda
        </h1>
        <p className="mt-6 text-base md:text-lg text-zinc-400 max-w-2xl mx-auto leading-relaxed">
          Precios simples y transparentes — ves exactamente qué incluye cada plan de Sera,
          sin sorpresas ni letra pequeña.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {TRUST_POINTS.map((p) => (
            <span key={p.text} className="flex items-center gap-2 text-sm text-zinc-400">
              <p.icon size={15} className="text-[#00E5FF]" />
              {p.text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
